import React from 'react';
import Css from './FiltrtagCloud.module.css';
import close from './../../../../../img/close-button-icon.png';
import open from './../../../../../img/close-button-icon-color.png';
import { paramsQuerryChekerUrlTagNameCloud } from '../../../DisplayComponent';


const FiltrtagCloud = (props) => {
    
    const [checked, setChecked] = React.useState(props.checked);

    const [valueagNameImage, setTagNameImage] = React.useState([]);


    const MouseOver = (e) => {
        let ff = Array(e.target.previousSibling.dataset.id, false)
        setTagNameImage(ff);
    }
    const MouseOut = (e) => {
        let ff = Array(e.target.previousSibling.dataset.id, true)
        setTagNameImage(ff);
    }


    const ClickClose = (e) => {
        let filter = "";
        let currentPage= 1;
        let valueSelected= props.valueSelected;
        let code = e.target.previousSibling.dataset.code;
        let value = e.target.previousSibling.dataset.id;
        for (var key in props.checked) {
          props.checked[key].map(u => {
            if(value !== u ){
                if(value.split('-')?.length == 2 && code !== key){
                    filter += `filter[${key}][]=${u}&`;
                }
                if(value.split('-')?.length == 1 && code == key){
                    filter += `filter[${key}][]=${u}&`;
                }
                
            }
            
          })
        }
        //?filter[style][]=356
        filter = filter.trim().slice(0, -1);
        
       
        props.setFiltr("?" + filter);
        props.getCatalogItems(props.pageSize, currentPage, "&" + filter + "&" + valueSelected);
        
        props.getFiltersUrl(filter);
        props.params.navigate(`/${props.catalogUrl}/?` + filter + "&" + valueSelected);

        let  checked=[];
        for (var key in props.checked) {
            props.checked[key].map(u => {
              if(value !== u ){
                if(value.split('-')?.length == 2 && code !== key){

                if (checked.hasOwnProperty(key)) {

                    let currentIndex = checked[key].indexOf(u);
                    if (currentIndex === -1) {
                        checked[key].push(String(u));
                    } else {
                        checked[key].splice(currentIndex, 1);
                    }
        
        
                }
                else {
                    if (key != "")
                        checked[key] = [String(u)];
                }

            }
            if(value.split('-')?.length == 1 && code == key){
                if (checked.hasOwnProperty(key)) {

                    let currentIndex = checked[key].indexOf(u);
                    if (currentIndex === -1) {
                        checked[key].push(String(u));
                    } else {
                        checked[key].splice(currentIndex, 1);
                    }
        
        
                }
                else {
                    if (key != "")
                        checked[key] = [String(u)];
                }
            }

              }
              
            })
          }
        

        setChecked(checked)
        props.setCheckenFiltr(checked);

    }

    const ClickOpen = (e) => {
        let currentPage= 1;
        let valueSelected= props.valueSelected;
        let filter = e.target.dataset.url;
        let code = e.target.dataset.code;
        let value = e.target.dataset.id;

        
        props.setFiltr("?" + filter);
        props.getCatalogItems(props.pageSize, currentPage, "&" + filter + "&" + valueSelected);
        
        props.getFiltersUrl(filter);
        props.params.navigate(`/${props.catalogUrl}/?` + filter + "&" + valueSelected);
        let  checked=[];
        checked[code]=value.split('-');

        setChecked(checked)
        props.setCheckenFiltr(checked);

    }
    
    
    return (
        <div className={Css.filtrRez} >
            {paramsQuerryChekerUrlTagNameCloud(props).map((u, i) => {
                return (
                    <div key={i} className={Css.itemFiltrRez} title={"перейти"} >
                        <span
                            onClick={ClickOpen}
                            data-id={u.value}
                            data-url={u.url}
                            data-code={u.code}
                        >
                            {u.name}
                            {u.code == "ORGANZA_COLOR" &&
                                (
                                    <span style={{ backgroundColor: `#${u.value}`, marginLeft: "10px" }}></span>
                                )}
                        </span>
                        <img

                            onMouseOver={MouseOver}
                            onMouseOut={MouseOut}
                            onClick={ClickClose}
                            src={!valueagNameImage[1] && valueagNameImage[0] == u.value ? open : close}
                            alt={"Закрыть"}
                            title={"Закрыть"}
                        />
                    </div>
                )
            })


            }


        </div>
    )
}

export default FiltrtagCloud;